import { render, staticRenderFns } from "./WorkTabsTableContent.vue?vue&type=template&id=47ef2404"
import script from "./WorkTabsTableContent.vue?vue&type=script&lang=js"
export * from "./WorkTabsTableContent.vue?vue&type=script&lang=js"
import style0 from "./WorkTabsTableContent.vue?vue&type=style&index=0&id=47ef2404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports